<template>
  <v-app>
    <v-main>
      <v-container
        class="general-style"
        fluid
        fill-height
        fill-width
      >
        <v-layout
          align-center
          class="layout-style"
        >
          <v-card
            class="card-style"
          >
            <v-toolbar
              dark
              color="primary"
              class="toolbar-style"
            >
              <div class="toolbar-content">
                <v-toolbar-title class="title-style">
                  Privacy Policy
                </v-toolbar-title>
                <v-btn
                  icon
                  class="close-btn"
                  @click="goBack"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-toolbar>
            <v-card-text class="content-style">
              <div class="terms-content">
                <h1>ImmersiveLang Privacy Policy</h1>
                
                <p class="effective-date">
                  <strong>Effective Date:</strong> 02/12/2025
                </p>
                
                <p>Your privacy is important to us. This Privacy Policy explains what information we collect, how we use it, and what rights you have.</p>

                <h2>1. Information We Collect</h2>
                <p>We collect information to provide and improve our services.</p>
                <ul>
                  <li><strong>Personal Information:</strong> Information you give us voluntarily, like your name and email address when you create an account.</li>
                  <li><strong>Usage Data:</strong> Information collected automatically when you use the app, such as your IP address, device type, and how you use certain features.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p>We use your information to:</p>
                <ul>
                  <li>Provide, operate, and maintain our app and services.</li>
                  <li>Improve, personalize, and expand our app's features.</li>
                  <li>Understand and analyze how you use our app.</li>
                  <li>Communicate with you for updates or support.</li>
                </ul>

                <h2>3. Sharing Your Information</h2>
                <p>
                  We do not sell your personal data to third parties. We may share information with trusted partners and service providers who help us run our app (e.g., analytics providers) but only to the extent necessary for them to perform their services, and only if they agree to keep it confidential.
                </p>

                <h2>4. Data Security</h2>
                <p>
                  We employ robust security measures (like encryption and access controls) to protect your data. However, no method of transmission over the internet is 100% secure.
                </p>

                <h2>5. Your Data Rights</h2>
                <p>You may have rights including:</p>
                <ul>
                  <li>The right to access, update, or delete your information.</li>
                  <li>The right to object to or restrict how we use your data.</li>
                  <li>The right to withdraw consent (if applicable).</li>
                </ul>

                <h2>6. Changes to this Policy</h2>
                <p>
                  We may update this Privacy Policy. We will notify you of changes by posting the new policy within the app or on our website.
                </p>

                <h2>7. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at: {{ CONTACT_EMAIL }}
                </p>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="goBack"
              >
                Back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { CONTACT_EMAIL } from "@/assets/constants/constants";

export default {
  name: "TermsOfUse",
  data() {
    return {
      CONTACT_EMAIL,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.general-style {
  background: linear-gradient(135deg, #f5f3ff 0%, #e8e4f0 100%);
  min-height: 100vh;
  padding: 40px 20px;
}

.layout-style {
  justify-content: center;
  padding: 20px;
  width: 100%;
}

.card-style {
  max-width: 900px;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(47, 60, 133, 0.1);
  overflow: hidden;
  height: auto;
}

.title-style {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.5px;
  flex: 1;
  text-align: center;
}

.toolbar-style {
  padding: 0 !important;
}

.toolbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
}

.close-btn {
  margin-left: auto;
}

.content-style {
  max-height: 600px;
  overflow-y: auto;
  padding: 40px;
}

.terms-content {
  text-align: left;
}

.terms-content h2 {
  color: #2f3c85;
  font-size: 18px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 12px;
}

.terms-content h1 {
  color: #2f3c85;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
}

.effective-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
}

.terms-content h2:first-of-type {
  margin-top: 16px;
}

.terms-content p {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 16px;
}

.terms-content ul {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin-left: 24px;
  margin-bottom: 16px;
}

.terms-content ul li {
  margin-bottom: 8px;
}

:deep(.v-card__text) {
  padding: 0 !important;
}

</style>
